/* import axios from 'axios' */
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_ADMINISTRACAO_URL}${process.env.VUE_APP_API_PATH}`
const apiContratos = `${process.env.VUE_APP_API_CONTRATOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterItenPorContrato(contradoId) {
        return axiosJwt
            .get(`${api}/rm/contratos/${contradoId}/itenscontrato`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirDadosRm(dadosRMDto) {
        return axiosJwt
            .post(`${apiContratos}/contratos/dadosrm`, dadosRMDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterInformacoesComplementaresContratoRM() {
        return axiosJwt
            .get(`${api}/rm/contratos/obterinformacoescomplementarescontratorm`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDadosContratoRM(contratoId) {
        return axiosJwt
            .get(`${api}/rm/contratos/obterdadoscontratorm/${contratoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTiposProdutoRM() {
        return axiosJwt
            .get(`${api}/rm/contratos/tiposprodutorm`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTiposFaturamentoRM() {
        return axiosJwt
            .get(`${api}/rm/contratos/tipofaturamentorm`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterNaturezasRM() {
        return axiosJwt
            .get(`${api}/rm/contratos/naturezasrm`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
